<template>
  <b-container fluid>
    <b-table
      responsive
      bordered
      :fields="testTableFields"
      :items="testsComputed"
    >
      <template slot="HEAD_selection">
        <b-form-checkbox
          v-model="selectionAll"
          :disabled="!editable || tests.length <= 0"
          @change="selectedAll"
        />
      </template>
      <template slot="selection" slot-scope="data">
        <b-form-checkbox
          v-model="testsSelected"
          :disabled="!editable"
          :value="data.item.test_id"
        />
      </template>
      <template slot="price" slot-scope="data">
        <b-form-input
          v-model="testsComputed[data.index].price"
          class="col-right"
          :disabled="isSelected(data.item.test_id) || !editable"
          size="sm"
          type="number"
          @input="editData(data.index)"
        />
      </template>
      <template slot="quantity" slot-scope="data">
        <b-form-input
          v-model="testsComputed[data.index].quantity"
          class="col-right"
          :disabled="isSelected(data.item.test_id) || !editable"
          size="sm"
          type="number"
          @input="editData(data.index)"
        />
      </template>
      <template slot="total_price" slot-scope="data">
        <div class="col-right">
          {{ data.item.total_price }}
        </div>
      </template>
      <template slot="ln" slot-scope="data">
        <div class="col-right">
          {{ data.item.ln }}
        </div>
      </template>
      <template slot="patient" slot-scope="data">
        <div class="col-left">
          {{ data.item.patient }}
        </div>
      </template>
      <template slot="spp" slot-scope="data">
        <div class="col-left">
          {{ data.item.spp }}
        </div>
      </template>
      <template slot="test_item" slot-scope="data">
        <div class="col-left">
          {{ data.item.test_item }}
        </div>
      </template>
      <template slot="approver.user.name" slot-scope="data">
        <div class="col-left">
          {{ data.item.approver.user.name }}
        </div>
      </template>
      <template slot="remark" slot-scope="data">
        <b-form-input
          v-model="testsComputed[data.index].remark"
          class="col-left"
          :disabled="
            isSelected(data.item.test_id) || !editable || !data.item.is_edit
          "
          size="sm"
          type="text"
        />
      </template>
    </b-table>
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "TestTableSelection",
  props: {
    // tests: {
    //   required: true
    // },
    // testsSelected: {
    //   type: Array
    // }
    editable: {
      default: false,
    },
  },
  computed: {
    testsComputed: {
      get() {
        return this.tests;
      },
      set(val) {
        this.$store.commit("Account/SET_TESTS", val);
      },
    },
    ...mapGetters({
      tests: "Account/getTests",
    }),
    testsSelected: {
      get() {
        return this.$store.state.Account.testsSelected;
      },
      set(value) {
        this.$store.commit("Account/SET_TESTS_SELECTED", value);
      },
    },
  },
  data() {
    return {
      selectionAll: false,
      testTableFields: {
        selection: {},
        ln: {
          label: "LN",
          key: "ln",
          sortable: true,
        },
        patient: {
          label: "PATIENT",
          key: "patient",
          sortable: true,
        },
        spp: {
          label: "SPP",
          key: "spp",
          sortable: true,
        },
        testName: {
          label: "รายการตรวจ",
          key: "test_item",
          sortable: true,
        },
        price: {
          label: "ราคาต่อหน่วย",
          key: "price",
          sortable: true,
        },
        quantity: {
          label: "จำนวน",
          key: "quantity",
          sortable: true,
        },
        totalPrice: {
          label: "ราคารวม",
          key: "total_price",
          sortable: true,
        },
        approver: {
          label: "ผู้อนุมัติ",
          key: "approver.user.name",
          sortable: true,
        },
        remark: {
          label: "หมายเหตุ",
          key: "remark",
          sortable: true,
        },
      },
    };
  },
  watch: {
    testsSelected(val) {
      if (this.testsSelected.length > 0) {
        this.selectionAll = this.testsSelected.length === this.tests.length;
      } else {
        this.selectionAll = false;
      }
    },
  },
  methods: {
    selectedAll(value) {
      if (value)
        this.testsSelected = [...this.tests.map((order) => order.test_id)];
      else this.testsSelected = [];
    },
    isSelected(id) {
      return !this.testsSelected.includes(id);
    },
    editData(index) {
      let price =
        this.testsComputed[index].price > 0
          ? this.testsComputed[index].price
          : 0.01;
      let quantity = this.testsComputed[index].quantity;

      this.$nextTick(() => {
        this.testsComputed[index].quantity =
          parseInt(quantity) >= 1 ? parseInt(quantity) : 1;
        this.testsComputed[index].price = price;
        this.testsComputed[index].total_price = price * quantity;

        if (
          this.testsComputed[index].total_price !==
          this.testsComputed[index].default_total_price
        ) {
          this.testsComputed[index].is_edit = true;
        } else {
          this.testsComputed[index].is_edit = false;
        }
      });
    },
  },
};
</script>

<style scoped></style>
